import React from 'react';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {useStyles} from './helpers';

const BlockTitleGroup = ({showBlock, setShowBlock, title}) => {
    const classes = useStyles();

    return (
        <div className={classes.titleGroup}
            onClick={() => setShowBlock(!showBlock)}
        >
            <h3 className={classes.headerGroup}>{title}</h3>
            {!showBlock && <ArrowRight className={classes.arrowGroup}/>}
            {showBlock && <ArrowDown className={classes.arrowGroup}/>}
        </div>
    )
}

export default BlockTitleGroup;